import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { withTranslate } from 'shared/hocs/withTranslate';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import ModalContainer from 'shared/components/ModalContainer/ModalContainer';
import s from './InfoModal.css';

const infoList = [
  'Выбирайте модель автомобиля',
  'Заполняйте онлайн-форму на сайте продавца',
  'Получайте телефонную консультацию',
  'Оформляйте заказ онлайн',
  'Финальный шаг – безопасная передача автомобиля',
];

class InfoModal extends React.Component {
  static propTypes = {
    switchModal: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
  };

  render() {
    const { showModal, switchModal, isMobile, t } = this.props;

    return (
      <ModalContainer
        modalCN={cx(s.modal, { [s.mobileModal]: isMobile })}
        onClose={switchModal}
        isOpen={showModal}
      >
        <div onClick={switchModal} className={isMobile ? s.mobileRoot : s.desktopRoot}>
          <div className={cx(s.mainInfoText, { [s.mobileMainInfoTex]: isMobile })}>
            {t(
              'Для обеспечения безопасности клиентов вы можете купить автомобиль в онлайн режиме. При покупке в онлайн режиме действует указанная скидка от заявленной цены.',
            )}
          </div>
          <div className={s.optionSection}>
            <div className={s.optionTitle}>{t('Как купить онлайн:')}</div>
            {infoList.map((item, index) => (
              <div className={s.modalOptions} key={item}>
                <div className={s.optionItemTitle}>{index + 1}.</div>
                <div className={s.optionItemText}>{t(item)}</div>
              </div>
            ))}
          </div>
        </div>
        <span className={s.closeBtn} onClick={switchModal} />
      </ModalContainer>
    );
  }
}

export default withStyles(s)(withTranslate(InfoModal));



// WEBPACK FOOTER //
// ./src/shared/components/Discount/InfoModal/InfoModal.js